module.exports = __webpack_public_path__ + "static/media/logoCopperUltralightShadow.69af433f.svg";